<div class="admin-page-container">
  <div class="admin-page-header">Module Management</div>
  <div class="admin-page-body">
    <kendo-grid [data]="gridData"
                [skip]="skip"
                (edit)="editHandler($event)"
                (remove)="removeHandler($event)"
                (add)="addHandler($event)"
                (pageChange)="pageChange($event)"
                [pageable]="{
                  buttonCount:10,
                  info:true,
                  pageSizes:true,
                  previousNext:true,
                  responsive:true,
                  position: 'bottom'
              }"
                [pageSize]="pageSize"
                [rowClass]="rowCallback">
      <ng-template kendoGridToolbarTemplate>
        <input placeholder="Search..."
               kendoTextBox
               (input)="onFilter($event.target)" />
        <kendo-grid-spacer></kendo-grid-spacer>
        <button kendoGridAddCommand type="button"><span class="fas fa-plus" title="Add New Module"></span></button>
        <button kendoGridExcelCommand type="button" title="Export to Excel">
          <span class="fas fa-file-excel"></span>
        </button>
      </ng-template>
      <kendo-grid-column [hidden]="true" field="id" title="Id"></kendo-grid-column>
      <kendo-grid-column field="name" title="Name"></kendo-grid-column>
      <kendo-grid-column field="description" title="Description"></kendo-grid-column>
      <kendo-grid-column field="hasApi" title="Has Admin API">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [className]="checkBox(dataItem.hasApi)"></span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="apiUrl" title="API Url"></kendo-grid-column>
      <kendo-grid-column field="apiKey" title="API Key"></kendo-grid-column>
      <kendo-grid-column field="sortOrder" title="Sort" editor="numeric" format="#"></kendo-grid-column>
      <kendo-grid-column field="isActive" title="Active" [width]="75">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [className]="checkBox(dataItem.isActive)"></span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="applicationId" title="Application Id"></kendo-grid-column>
      
      <kendo-grid-command-column title="Action" [width]="100">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem="dataItem">
          <button kendoGridEditCommand [primary]="true" title="Edit Module"><span class="far fa-pencil"></span></button>
        </ng-template>
      </kendo-grid-command-column>
      <kendo-grid-excel [fetchData]="allData" fileName="Modules_Dump.xlsx"></kendo-grid-excel>
      <ng-template kendoPagerTemplate
                   let-totalPages="totalPages"
                   let-currentPage="currentPage">


        <div class="custom-pager">
          <div class="custom-pager-pagesize">View&nbsp;&nbsp; <kendo-dropdownlist [data]="sizes" [(ngModel)]="pageSize" (valueChange)="pageSizeChange($event)"></kendo-dropdownlist></div>
          <div class="custom-pager-jump"><kendo-pager-input></kendo-pager-input></div>
          <div class="custom-pager-items"><kendo-pager-prev-buttons></kendo-pager-prev-buttons> {{startnum()}} - {{endnum()}} of {{gridData.total}} <kendo-pager-next-buttons></kendo-pager-next-buttons></div>
        </div>
      </ng-template>
    </kendo-grid>

  </div>
</div>


